module.exports = __webpack_public_path__ + "img/UnAutorized.22121c56.png";